import React from 'react'
import { TextField } from '@mui/material';
import "../assets/Styles/InputComp.css";
import { inputChecks } from "../Utilities/InputChecks"





function InputComp(props) {
    return (
        <div className="input-component">
            <p className="input-title">{props.title}{props?.asterisk ? <span style={{ color: "red" }}>*</span> : ""} </p>
            <TextField
                {...props.register(props.name, inputChecks(props.type, props.name))}
                multiline={props.multiline}
                rows={5}
                value={props.value}
                onChange={(event) => props.setValue(event.target.value.toString())}
                error={props.error}
                variant='outlined' type={props.type} name={props.name}
                helperText={props.errorMessage ? props.errorMessage : null}
                placeholder={props.placeholder}
                inputProps={{
                    maxLength: props.maxLength,
                }}>
            </TextField>
        </div>
    )
}

export default InputComp
